import { Component, Input, OnInit } from "@angular/core";
import { ScrBaseComponent } from "src/app/components/base.component";
import { DialogEvent } from "../../components/custom-controls/dynamic-dialog/dynamic-dialog.component";
import { DialogName } from "../../models/constants";
import { ConfigPipe } from "../config.pipe";
import { ConfigService } from "../../services";


@Component({
  templateUrl: './vet-results-dialog.component.html',
  styleUrl: './vet-results-dialog.component.scss'
})

export class VetResultsDialogComponent extends ScrBaseComponent implements OnInit {

  @Input() callback!: (event: DialogEvent) => void;

  @Input() entityName!: string; // provided locally.  remainder from API.
  @Input() entityType!: string; // Brand or ContentProvider

  @Input() vetStatus!: string;
  @Input() vetReportId!: string;
  @Input() vetDate!: Date;
  @Input() vetRequestId!: string;
  @Input() errorDescription?: string;
  @Input() vettedEntity?: string;
  @Input() findings?: string[];

  constructor(private svc: ConfigService) {
    super();
  }

  public ngOnInit() {
    if (this.entityType) {
      this.entityType = new ConfigPipe(this.svc).transform(this.entityType, 'entityType') as string;
    }
  }

  public close(): void {
    this.callback({ name: DialogName.VetResults, isCompleted: true } );

  }
}